import { Chat } from "@pages:app/talk/Chat/Chat";
import { TalkLayout } from "@pages:app/talk/TalkLayout";

export const TalkChat = () => {
  return (
    <TalkLayout>
      <Chat />
    </TalkLayout>
  );
};
